import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import { useTvShowEpisodesQuery } from "@/hooks";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TvShowEpisodesList(_ref) {
  let {
    id,
    showHeader = false
  } = _ref;
  const _useTvShowEpisodesQue = useTvShowEpisodesQuery({
      variables: {
        id,
        offset: 0,
        limit: LIST_PAGE_LIMIT
      },
      fetchPolicy: "cache-first",
      nextFetchPolicy: "cache-first"
    }),
    {
      data
    } = _useTvShowEpisodesQue,
    result = _objectWithoutProperties(_useTvShowEpisodesQue, _excluded);
  const items = data === null || data === void 0 ? void 0 : data.children;
  const header = useMemo(() => {
    if (showHeader) {
      return {
        text: "エピソード一覧"
      };
    } else {
      return null;
    }
  }, [showHeader]);
  return /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
    itemComponent: ListRow,
    header: header,
    items: items,
    limit: LIST_PAGE_LIMIT,
    viewTypeClassName: "list"
  }));
}